import api, { ValidateAxiosError, } from '@/modules/api.service';
import { CreateVaraDto, ReadVaraDto, UpdateVaraDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindVaraDto } from '@/api.types.extra';

const endpoint = Endpoints.VARA;

export async function createVara(dto: CreateVaraDto) {
  try {
    const response = await api.post(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a vara.');
  }
}

export async function readVara(filters: FindVaraDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadVaraDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar vara(s).');
  }
}

export async function updateVara(dto: UpdateVaraDto) {
  try {
    const response = await api.put(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a vara.');
  }
}

export async function deleteVara(id: number) {
  try {
    const response = await api.delete(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a vara.');
  }
}